import { useRef, useState, useContext } from 'react';
import emailjs from 'emailjs-com';
import { ThemeContext } from '../../context';

// css
import styles from './Contact.module.css';

// icon
import Phone from '../../img/telephone.png';
import Email from '../../img/email_1.png';
import Github from '../../img/github.png';

function Contact() {
  // form action
  // 給form接收的直
  const formRef = useRef();
  const [done, setDone] = useState(false);
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  const submitHandler = (e) => {
    e.preventDefault();
    console.log('formRef.current: ', formRef.current.name);
    emailjs
      .sendForm(
        'service_odgagi8',
        'template_ian2tpg',
        formRef.current,
        'user_9ecwBUYCLt0QN1hspjkcX',
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
          // 送出後清空form
          document.getElementById('my-form').reset();
        },
        (error) => {
          console.log(error.text);
        },
      );
  };

  return (
    <div className={styles['contact']}>
      <div className={styles['contact-bg']}></div>
      <div className={styles['contact-wrapper']}>
        <div className={styles['contact-left']}>
          <h1 className={styles['contact-title']}>我的聯絡資訊</h1>
          <div className={styles['contact-info']}>
            <div className={styles['contact-info-item']}>
              <img className={styles['contact-icon']} src={Phone} alt="phone" />
              0972865825
            </div>
            <div className={styles['contact-info-item']}>
              <a href="mailto:q20038848@gmail.com">
                <img
                  className={styles['contact-icon']}
                  src={Email}
                  alt="email"
                />
              </a>
              q20038848@gmail.com
            </div>
            <div className={styles['contact-info-item']}>
              <a
                href="https://github.com/felixtt0201"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className={styles['contact-icon']}
                  src={Github}
                  alt="github"
                />
              </a>
              https://github.com/felixtt0201
            </div>
          </div>
        </div>
        <div className={styles['contact-right']}>
          <p className={styles['contact-desc']}>
            如果我是你要找的員工、同事，甚至是夥伴
            <b> 歡迎隨時來信聯絡我！</b>
          </p>
          <form ref={formRef} onSubmit={submitHandler} id="my-form">
            <input
              style={{ backgroundColor: darkMode && '#333' }}
              type="text"
              placeholder="name"
              name="user_name"
              required
            />
            <input
              style={{ backgroundColor: darkMode && '#333' }}
              type="text"
              placeholder="Subject"
              name="user_subject"
              required
            />
            <input
              style={{ backgroundColor: darkMode && '#333' }}
              type="email"
              placeholder="Email"
              name="user_email"
              required
            />
            <textarea
              style={{ backgroundColor: darkMode && '#333' }}
              rows="5"
              placeholder="Message"
              name="message"
              required
            ></textarea>
            <div className={styles['contact-button']}>
              <button>Submit</button>
            </div>
            {done && '感謝您的來信'}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
